import { UserInformation } from './actions';

export interface AuthState {
  pending: boolean;
  user: UserInformation | null;
  error?: string;
}

export const defaultAuthState: AuthState = {
  pending: false,
  user: null,
  error: null,
};

export interface RecoverState {
  pending: boolean;
  outcome: string;
  error?: string;
}

export const defaultRecoverState: RecoverState = {
  pending: false,
  outcome: '',
  error: null,
};
